// import { useState } from "react";
// import { Link, useLocation } from "react-router-dom";

// const MenuItem = (prop) => {
//   const item = prop.item;
//   const index = prop.index;
//   var location = useLocation();
//   const [open, setOpen] = useState(false);

//   return (
//     <li
//       data-bs-theme="dark"
//       className={
//         "sidebar-item" +
//         (item.submenu ? " has-sub" : "") +
//         (location.pathname === item.url ||
//         (item.submenu && item.submenu.filter((si) => si.url === location.pathname).length > 0)
//           ? " active"
//           : "")
//       }>
//       <Link
//         to={item.url}
//         className="sidebar-link"
//         onClick={() => {
//           setOpen(!open);
//         }}>
//         <i className={item.icon}></i>
//         <span>{item.title}</span>
//       </Link>
//       {item.submenu && (
//         <ul className={"submenu" + (open ? " active" : "")}>
//           {item.submenu.map((subitem, subIndex) => {
//             return (
//               <li
//                 className={"submenu-item" + (location.pathname === subitem.url ? " active" : "")}
//                 key={"submenu" + index + subIndex}>
//                 <Link to={subitem.url} className="submenu-link">
//                   {subitem.title}
//                 </Link>
//               </li>
//             );
//           })}
//         </ul>
//       )}
//     </li>
//   );
// };

// export default MenuItem;

import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const MenuItem = (prop) => {
  const item = prop.item;
  const index = prop.index;
  const isDirty = prop.isDirty;
  const setShowModal = prop.setShowModal;
  const setPendingRoute = prop.setPendingRoute;

  var location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleNavigation = (e, url) => {
    if (isDirty) {
      e.preventDefault();
      setPendingRoute(url);
      setShowModal(true);
      return;
    }
  };

  return (
    <li
      data-bs-theme="dark"
      className={
        "sidebar-item" +
        (item.submenu ? " has-sub" : "") +
        (location.pathname === item.url ||
        (item.submenu && item.submenu.filter((si) => si.url === location.pathname).length > 0)
          ? " active"
          : "")
      }>
      <Link
        to={item.url}
        className="sidebar-link"
        onClick={(e) => {
          setOpen(!open);
          handleNavigation(e, item.url);
        }}>
        <i className={item.icon}></i>
        <span>{item.title}</span>
      </Link>

      {item.submenu && (
        <ul className={"submenu" + (open ? " active" : "")}>
          {item.submenu.map((subitem, subIndex) => {
            return (
              <li
                className={"submenu-item" + (location.pathname === subitem.url ? " active" : "")}
                key={"submenu" + index + subIndex}>
                <Link
                  to={subitem.url}
                  className="submenu-link"
                  onClick={(e) => handleNavigation(e, subitem.url)}>
                  {subitem.title}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};

export default MenuItem;
